import * as XLSX from 'xlsx/xlsx.mjs';
import { v4 as uuidv4 } from 'uuid';

export const importExcel = async (file, wishCount) => {
    const workbook = XLSX.read(await file.arrayBuffer());

    const sheetNames = workbook.SheetNames;

    const firstSheet = workbook.Sheets[workbook.SheetNames[0]];

    const dataAsArrayOfArrays = XLSX.utils.sheet_to_json(firstSheet, { header: 1, defval: "" });

    const finalData = dataAsArrayOfArrays.flatMap((lineInSheet) => {
        if (!Array.isArray(lineInSheet) || lineInSheet.length === 0) return [];
        if (!lineInSheet[0]) lineInSheet[0] = "Unbenannt";
        let w = lineInSheet.slice(1, Math.min(lineInSheet.length, wishCount+1));
        w = w.map((wish) => wish ? wish.toString() : "");
        w = w.map((wish) => wish.trim());
        w = w.map((wish) => wish.replaceAll(/“/g, "")); // TODO this catches only the first occurence for some reason
        w = w.map((wish) => wish.replaceAll(/”/g, "")); // TODO this catches only the first occurence for some reason
        w = w.map((wish) => (wish == null || wish == undefined) ? "" : wish); // should actually not happen because of defval: "" above
        while (w.length < wishCount+1) {
            w.push("");
        }
        return [{"id": uuidv4(), "name": lineInSheet[0].toString().trim(), "wishes": w}];
    });

    return [finalData, sheetNames];
}
